// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7bc5fc4c","455":"0751c0ce","977":"f5827a2b"}[chunkId] + ".chunk.js";
};